import api from '@/services/api'

export default {
  getSales(page, term) {
    return api.get(`/sales?all=true&page=${page}&term=${term}`)
  },

  getBoardSales() {
    return api.get('/sales?board=true');
  },

  getSale(id) {
    return api.get(`/sales/${id}`)
  },

  changeStatus(id, status) {
    return api.put(`/sales/${id}/change-status/${status}`);
  },

  downloadSale(id) {
    return api({
      url: `/sales/${id}/download`,
      method: 'GET',
      responseType: 'blob',
    })
  },

  getAbandonedCarts(page) {
    return api.get(`/reports/abandoned-carts?page=${page}`)
  },

  updateItems(id, items) {
    return api.put(`/sales/${id}/items`, { items })
  },

  downloadAbandonedCarts() {
    return api.get(`/reports/abandoned-carts?download=true`)
  }
}